import { render, staticRenderFns } from "./RepeatArtworks.vue?vue&type=template&id=1e8f23cf"
import script from "./RepeatArtworks.vue?vue&type=script&lang=js"
export * from "./RepeatArtworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports